import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3057a67a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container px-0 py-9"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Excel mappings", -1))
const _hoisted_3 = { enctype: "multipart/form-data" }
const _hoisted_4 = {
  class: "table--responsive-scroll",
  style: {"max-height":"550px","overflow-x":"hidden"}
}
const _hoisted_5 = {
  class: "table table--selectable w-percent-100",
  id: "selectable-table1",
  style: {"min-width":"100%","table-layout":"fixed"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("caption", null, "Nøgler som mangler mapnings", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"12%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"13%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"13%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"13%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"23%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"20%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"6%"} })
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Scopes (s1/s2/s3/os)", -1))
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = ["value"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: 'input_filter' }, [
  /*#__PURE__*/_createElementVNode("span", null, "Filtrer Enhed for bedste hit")
], -1))
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["value"]
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  class: "table--responsive-scroll",
  style: {"max-height":"550px","overflow-y":"auto","overflow-x":"hidden"}
}
const _hoisted_19 = {
  class: "table table--selectable",
  id: "selectable-table2",
  style: {"min-width":"100%","table-layout":"fixed"}
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("caption", null, "EMF Master data med egen EMC", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"10%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"7%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"15%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"8%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"15%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"15%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"30%"} })
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Scopes (s1/s2/s3/os)", -1))
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = {
  id: "button-container-div",
  class: "pb-6"
}
const _hoisted_28 = {
  class: "table--responsive-scroll",
  style: {"max-height":"550px","overflow-y":"auto","overflow-x":"hidden"}
}
const _hoisted_29 = {
  class: "table table--selectable",
  id: "selectable-table3",
  style: {"min-width":"100%","table-layout":"fixed"}
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("caption", null, "Excel mapninger", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"10%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"10%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"40%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"40%"} })
], -1))
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  key: 1,
  class: "container px-0 py-9"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.pageAccess)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("section", null, [
          _createElementVNode("form", _hoisted_3, [
            _createElementVNode("button", {
              class: "button button-primary",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.dummyUploadFile()), ["prevent"]))
            }, "Vælg Excel fil"),
            _createElementVNode("input", {
              style: {"display":"none"},
              type: "file",
              id: `map-fileinput`,
              name: "file",
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addFile && _ctx.addFile(...args)))
            }, null, 32),
            _createTextVNode(" SheetName: "),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "form-input-4",
              class: "form-control",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.sheetName) = $event)),
              placeholder: "f.eks. 2022v1"
            }, null, 512), [
              [_vModelText, _ctx.sheetName]
            ])
          ]),
          _createElementVNode("h2", null, "Excel nøgler som mangler mapping (" + _toDisplayString(_ctx.excelNonMappedKeys.length) + ")", 1),
          _createElementVNode("p", null, "Filnavn: " + _toDisplayString(_ctx.excelFileName.fileName), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("table", _hoisted_5, [
              _hoisted_6,
              _hoisted_7,
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sortExcelNonMappedKeys('mainCategory')))
                  }, "Hovedkategori"),
                  _createElementVNode("th", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sortExcelNonMappedKeys('category')))
                  }, "Kategori"),
                  _createElementVNode("th", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sortExcelNonMappedKeys('parameter1')))
                  }, "Parameter 1"),
                  _createElementVNode("th", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sortExcelNonMappedKeys('parameter2')))
                  }, "Parameter 2"),
                  _createElementVNode("th", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sortExcelNonMappedKeys('key')))
                  }, "Excel nøgle"),
                  _hoisted_8,
                  _createElementVNode("th", {
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sortExcelNonMappedKeys('unit')))
                  }, "Enhed")
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.excelNonMappedKeys, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.key,
                    onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.sortTablesBySelectedUnit && _ctx.sortTablesBySelectedUnit(...args))),
                    onClick: ($event: any) => (_ctx.selectRowToMap(item.key, true)),
                    class: _normalizeClass({ "selected-row":  _ctx.isSelected(item.key)})
                  }, [
                    _createElementVNode("td", null, _toDisplayString(item.mainCategory), 1),
                    _createElementVNode("td", null, _toDisplayString(item.category), 1),
                    _createElementVNode("td", null, _toDisplayString(item.parameter1), 1),
                    _createElementVNode("td", null, _toDisplayString(item.parameter2), 1),
                    _createElementVNode("td", null, _toDisplayString(item.key), 1),
                    _createElementVNode("td", null, [
                      _createTextVNode(_toDisplayString(item.scope1), 1),
                      _hoisted_10,
                      _createTextVNode(_toDisplayString(item.scope2), 1),
                      _hoisted_11,
                      _createTextVNode(_toDisplayString(item.scope3), 1),
                      _hoisted_12,
                      _createTextVNode(_toDisplayString(item.outsideScope), 1)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.unit), 1)
                  ], 42, _hoisted_9))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("input", {
            id: 'input_filter',
            type: "checkbox",
            name: "selectable-table2-check[]",
            class: "form-checkbox",
            value: _ctx.filterByUnit,
            onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.filterByUnitToggle(_ctx.isSelected(this.excelKeyToMap !== '' ? this.excelKeyToMap : this.masterKeyToMap))))
          }, null, 40, _hoisted_13),
          _hoisted_14,
          _createTextVNode("       Filtrer via indhold: "),
          _createElementVNode("input", {
            type: "text",
            id: "filterInput",
            onKeyup: _cache[11] || (_cache[11] = ($event: any) => (_ctx.filterInput())),
            placeholder: "Filtrer..",
            title: "Skriv søgekriterie"
          }, null, 32),
          _createElementVNode("h2", null, "EMF Master data med egen EMC (" + _toDisplayString(_ctx.emfMasterdataList.length) + ")", 1),
          (_ctx.sortedVersions?.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createTextVNode(" Hent scope værdier for version: "),
                _withDirectives(_createElementVNode("select", {
                  class: "form-select",
                  value: _ctx.emissionFactorYearVersion,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.emissionFactorYearVersion) = $event)),
                  name: "versions"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...this.versions?.versions], (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item.id,
                      value: item.id
                    }, _toDisplayString(item.year) + "v" + _toDisplayString(item.version), 9, _hoisted_17))
                  }), 128))
                ], 8, _hoisted_16), [
                  [_vModelSelect, _ctx.emissionFactorYearVersion]
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("table", _hoisted_19, [
              _hoisted_20,
              _hoisted_21,
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.sortEMFMasterData('key')))
                  }, "Key"),
                  _createElementVNode("th", {
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.sortEMFMasterData('subgroupingId')))
                  }, "Subgrp."),
                  _createElementVNode("th", {
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.sortEMFMasterData('subgroupingName')))
                  }, "Subgrp. navn"),
                  _createElementVNode("th", {
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.sortEMFMasterData('unit')))
                  }, "Enhed"),
                  _createElementVNode("th", {
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.sortEMFMasterData('information')))
                  }, "Field_enum"),
                  _hoisted_22,
                  _createElementVNode("th", {
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.sortEMFMasterData('description')))
                  }, "Beskrivelse"),
                  _createElementVNode("th", {
                    onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.sortEMFMasterData('hasOwnEMC')))
                  }, "Egen EMC")
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emfMasterdataList, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id,
                    onChange: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.sortTablesBySelectedUnit && _ctx.sortTablesBySelectedUnit(...args))),
                    onClick: ($event: any) => (_ctx.selectRowToMap(item.key, false)),
                    class: _normalizeClass({ "selected-row":  _ctx.isSelected(item.key) })
                  }, [
                    _createElementVNode("td", null, _toDisplayString(item.key), 1),
                    _createElementVNode("td", null, _toDisplayString(item.subgroupingId), 1),
                    _createElementVNode("td", null, _toDisplayString(item.subgroupingName), 1),
                    _createElementVNode("td", null, _toDisplayString(item.unit), 1),
                    _createElementVNode("td", null, _toDisplayString(item.information), 1),
                    _createElementVNode("td", null, [
                      _createTextVNode(_toDisplayString(item.scope1), 1),
                      _hoisted_24,
                      _createTextVNode(_toDisplayString(item.scope2), 1),
                      _hoisted_25,
                      _createTextVNode(_toDisplayString(item.scope3), 1),
                      _hoisted_26,
                      _createTextVNode(_toDisplayString(item.outsideScope), 1)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.description), 1),
                    _createElementVNode("td", null, _toDisplayString(item.hasOwnEMC ? 'Ja' : 'Nej'), 1)
                  ], 42, _hoisted_23))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("h2", null, "Excel mappings (" + _toDisplayString(_ctx.excelMappings.length) + ")", 1),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("button", {
              id: "submit-button-forecast",
              type: "submit",
              class: "button button-primary",
              title: "Når der er valgt nøgle of master data oprettes en mapning",
              onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.createMapping && _ctx.createMapping(...args)))
            }, "Gem "),
            _createElementVNode("button", {
              id: "submit-button-forecast3",
              type: "submit",
              class: "button button-primary",
              onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.deleteMapping())),
              title: "Slet excel mapping"
            }, "Slet "),
            _createElementVNode("button", {
              id: "submit-button-forecast2",
              type: "submit",
              class: "button button-primary",
              onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.exportToSqlString && _ctx.exportToSqlString(...args))),
              title: "Eksporter Excel mapping så anvendes fra andre miljøer"
            }, "Exporter SQL ")
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("table", _hoisted_29, [
              _hoisted_30,
              _hoisted_31,
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.sortExcelMappings('id')))
                  }, "id"),
                  _createElementVNode("th", {
                    onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.sortExcelMappings('emfKey')))
                  }, "EMF Key"),
                  _createElementVNode("th", {
                    onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.sortExcelMappings('emfDesc')))
                  }, "EMF Desc"),
                  _createElementVNode("th", {
                    onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.sortExcelMappings('excelKey')))
                  }, "ExcelKey")
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.excelMappings, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item,
                    onClick: ($event: any) => (_ctx.selectExcelMappingsRowToDelete(item.id)),
                    class: _normalizeClass({ "selected-row":  _ctx.isSelectedForDeletion(item.id) })
                  }, [
                    _createElementVNode("td", null, _toDisplayString(item.id), 1),
                    _createElementVNode("td", null, _toDisplayString(item.emfKey), 1),
                    _createElementVNode("td", null, _toDisplayString(item.emfDesc), 1),
                    _createElementVNode("td", null, _toDisplayString(item.excelKey), 1)
                  ], 10, _hoisted_32))
                }), 128))
              ])
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_33, "Din brugerprofil har ikke adgang til dette skærmbillede"))
}